import React, { useEffect, useState } from 'react';
import { Breadcrumb, Row } from 'react-bootstrap';

import { SettingsApiService } from 'Services/ApiServices';
import { toastr } from 'Helpers/ToastHelper';
import { useApiData, useModal } from 'Hooks';
import KeywordsTable from 'Views/Settings/KeywordsTable';
import TemplatesTable from 'Views/Settings/TemplatesTable';
import KeywordsDetailModal from 'Views/Settings/Modals/KeywordsDetailModal';
import IndividualTemplateModal from 'Views/Settings/Modals/IndividualTemplateModal';
import MaintenanceCard from 'Views/Settings/MaintenanceCard';

const SettingsKeywordsView = () => {
  const { data: settings, isLoading, refetch } = useApiData(() => SettingsApiService.getAll());
  const { data: maintenance } = useApiData(() => SettingsApiService.getMaintenance());

  const { isOpen: showEditKeywordModal, open: openKeywordModal, close: closeKeywordModal } = useModal();
  const { isOpen: showEditIndividualTemplateModal, open: openTemplateModal, close: closeTemplateModal } = useModal();

  const [currentKeywordRowData, setKeywordCurrentRowData] = useState({
    dropdownName: '',
    options: '',
    comments: '',
    createdAt: '',
  });

  const [currentIndividualTemplateData, setCurrentIndividualTemplateData] = useState({
    _id: '',
    title: '',
    description: '',
    category: '',
    parentId: '',
    dropdownName: '',
    isNew: false,
  });

  useEffect(() => {
    document.title = 'F2w - Settings';
  }, []);

  const handleEditKeyword = (keyword) => {
    setKeywordCurrentRowData({
      dropdownName: keyword.dropdownName,
      options: keyword.options || [],
      comments: keyword.comments || '',
      createdAt: keyword.createdAt,
    });
    openKeywordModal();
  };

  const handleEditTemplate = (template) => {
    setCurrentIndividualTemplateData({
      _id: template._id,
      title: template.title,
      description: template.description,
      category: template.category,
      parentId: template.parentId,
      dropdownName: template.dropdownName,
      isNew: false,
    });
    openTemplateModal();
  };

  const handleAddTemplate = () => {
    setCurrentIndividualTemplateData({
      _id: '',
      title: '',
      description: '',
      category: '',
      parentId: '',
      isNew: true,
    });
    openTemplateModal();
  };

  const handleDeleteTemplate = (template) => {
    const templateIndex = template._id.split('-')[1];
    toastr.confirm(`Are you sure you want to delete template "${template.title}"?`, {
      onOk: () => {
        SettingsApiService.deleteTemplateOption(template.parentId, templateIndex)
          .then(() => {
            toastr.success('Success', 'Template deleted successfully');
            refetch();
          })
          .catch(() => {
            toastr.error('Error', 'Failed to delete template');
          });
      },
    });
  };

  const handleDeleteKeyword = (keyword) => {
    toastr.confirm(`Are you sure you want to delete keyword "${keyword.dropdownName}"?`, {
      onOk: () => {
        SettingsApiService.deleteKeyword(keyword.id)
          .then(() => {
            toastr.success('Success', 'Keyword deleted successfully');
            refetch();
          })
          .catch(() => {
            toastr.error('Error', 'Failed to delete keyword');
          });
      },
    });
  };

  if (isLoading) return null;

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between align-items-center pt-2" style={{ height: '40px' }}>
        <h4>Settings</h4>
        <Breadcrumb className="mb-0">
          <Breadcrumb.Item href="/">F2w</Breadcrumb.Item>
          <Breadcrumb.Item href="/settings">Settings</Breadcrumb.Item>
          <Breadcrumb.Item active>Keywords</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <KeywordsTable
        settingsKeywordDatatable={settings?.keywords || []}
        handleEditKeyword={handleEditKeyword}
        handleDeleteKeyword={handleDeleteKeyword}
      />

      <TemplatesTable
        settingsTemplateDatatable={settings?.templates || []}
        handleEditTemplate={handleEditTemplate}
        handleAddTemplate={handleAddTemplate}
        handleDeleteTemplate={handleDeleteTemplate}
      />

      <MaintenanceCard maintenance={maintenance} />

      <IndividualTemplateModal
        showEditModal={showEditIndividualTemplateModal}
        setShowEditModal={closeTemplateModal}
        currentRowData={currentIndividualTemplateData}
        setRefreshComponent={refetch}
      />

      <KeywordsDetailModal
        showEditModal={showEditKeywordModal}
        setShowEditModal={closeKeywordModal}
        currentRowData={currentKeywordRowData}
        setRefreshComponent={refetch}
      />
      <Row style={{ marginTop: '2%' }}></Row>
    </React.Fragment>
  );
};

export default SettingsKeywordsView;
